import * as yup from 'yup';
import valid from 'card-validator';

const zipCodeRegExp = /\d{5}/;

const validationSchema = yup.object().shape({
  billing_city: yup
    .string()
    .min(1)
    .required('Billing city is required.'),
  billing_state: yup
    .string()
    .min(1)
    .required('Billing state is required.'),
  billing_street_address: yup
    .string()
    .min(1)
    .required('Billing address is required.'),
  billing_zip_code: yup
    .string()
    .min(5, 'Please enter a valid zip code')
    .max(5, 'Please enter a valid zip code')
    .matches(zipCodeRegExp, 'Please enter a valid zip code')
    .required('Please enter a zip code'),
  card_number: yup
    .string()
    .test(
      'test-number',
      'Credit Card number not valid',
      value => valid.number(value).isValid
    )
    .required(),
  cvv: yup
    .string()
    .min(3)
    .max(4)
    .required('CVV is required.'),
  email: yup
    .string()
    .email('Please enter a valid address')
    .required('Please enter your email address'),
  expiration_date: yup
    .string()
    .test(
      'test-expiration',
      'Expiration date not valid',
      value => valid.expirationDate(value).isValid
    )
    .required(),
  first_name: yup
    .string()
    .min(1, 'Must have at least one character')
    .required('Please enter your first name'),
  last_name: yup
    .string()
    .min(1, 'Must have at least one character')
    .required('Please enter your last name'),
  phone: yup
    .string()
    .min(1)
    .required('Please enter your phone number.'),
  processing: yup.string().required('Please make a selection.'),
});

export default validationSchema;
